import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PrivateRoute from "PrivateRoute";
import PublicRoute from "PublicRoute";
import MainLayout from "layouts/MainLayout";
import NotFound from "components/404";
import PaymentContainer from "./containers/PaymentContainer";

const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHER_KEY;
const PaymentPage = (props) => {
  const { match } = props;
  const [pk, setPk] = useState();
  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    setPk(STRIPE_PK);
  }, []);

  useEffect(() => {
    if (pk && !stripePromise) {
      setStripePromise(loadStripe(pk));
    }
  }, [pk, stripePromise]);

  return (
    <Switch>
      <Elements stripe={stripePromise}>
        <PrivateRoute
          path={`${match.url}`}
          component={PaymentContainer}
          layout={MainLayout}
        />
      </Elements>
      <PublicRoute component={NotFound} layout={MainLayout} />
    </Switch>
  );
};

PaymentPage.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default PaymentPage;
